var _defs, _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "loc-point",
    id: "pin",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 -20 40 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".locationicon-cls-1{fill:url(#pin-shad);}.locationicon-cls-2{fill:#e46d20;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "pin-shad",
    cx: 19.84,
    cy: 38.81,
    r: 7.13,
    gradientTransform: "translate(0 32.46) scale(1 0.16)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "pin-shadow",
    className: "locationicon-cls-1",
    cx: 19.84,
    cy: 38.81,
    rx: 10.02,
    ry: 1.19
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "loc-icon",
    className: "locationicon-cls-2",
    d: "M33.84,13.45C33.84,6.19,27.57.3,19.84.3s-14,5.89-14,13.15a12.53,12.53,0,0,0,1.44,5.78h0L16,36.14h0a4,4,0,0,0,7.62,0h0l8.74-16.9h0A12.45,12.45,0,0,0,33.84,13.45ZM19.84,20a6.81,6.81,0,0,1-7-6.57,6.81,6.81,0,0,1,7-6.58,6.8,6.8,0,0,1,7,6.58A6.78,6.78,0,0,1,19.84,20Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.6eb6cb1f95375fe3ac7c6b3c4be7d816.svg";
export { ForwardRef as ReactComponent };